$(document).ready(function() {
    // if ($("request_count").data('count') === 1) {
    //     return setTimeout(function() {
    //         return AsLib.update_location_with_current_loc();
    //     }, 1000);
    // }
});
